import { formatDistance, format } from 'date-fns';

export function date(value) {
  return new Date(value);
}

export function formatTime(date) {
  return format(date, 'PPpp');
}

export function formatTimeDistance(date, now) {
  return formatDistance(date, now, {
    addSuffix: true,
    includeSeconds: true,
  });
}

export function formatElapsedTime(date, now) {
  return formatDistance(date > now ? now : date, now, {
    addSuffix: true,
    includeSeconds: true,
  });
}

export const timeSpanRegex = /^((?:-?0*\d+\.)?(?:0*)(?:2[0-3]|1[0-9]|[0-9]))(?::0*([0-5]?[0-9]))?(?::0*((?:[0-5]?[0-9])(?:\.\d{0,7})?))?$/;
export const timeSpanWithSignRegex = /^[+\-]?((?:-?0*\d+\.)?(?:0*)(?:2[0-3]|1[0-9]|[0-9]))(?::0*([0-5]?[0-9]))?(?::0*((?:[0-5]?[0-9])(?:\.\d{0,7})?))?$/;
export const timeOffsetRegex = /^[+\-]?((?:-?0*\d+\.)?(?:0*)(?:2[0-3]|1[0-9]|[0-9]))(?::0*([0-5]?[0-9]))?$/;
